import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import React from 'react';
import { View } from 'react-native';
import DraggableTitle from './DraggableTitle';
import Title from './Title';
var Header = function Header(props) {
  var columns = props.columns,
    dimensions = props.dimensions,
    movableColumns = props.movableColumns,
    moveColumn = props.moveColumn,
    order = props.order,
    updateOrder = props.updateOrder,
    styles = props.styles,
    htmlTable = props.htmlTable;
  var style = _objectSpread({
    flexDirection: 'row',
    minHeight: 40,
    paddingHorizontal: 16,
    borderBottomWidth: 1,
    borderBottomStyle: 'solid',
    borderTopWidth: 1,
    borderTopColor: 'lightgray',
    borderTopStyle: 'solid'
  }, styles === null || styles === void 0 ? void 0 : styles.container);
  var TitleComponent = movableColumns ? DraggableTitle : Title;
  var children = columns.filter(function (options) {
    return !options.hidden;
  }).map(function (options, index) {
    var label = options.label,
      key = options.key,
      minViewportWidth = options.minViewportWidth,
      sort = options.sort,
      width = options.width,
      headerStyle = options.headerStyle;
    if (((dimensions === null || dimensions === void 0 ? void 0 : dimensions.width) || 999999999) < (minViewportWidth || 0)) {
      return null;
    }
    return /*#__PURE__*/React.createElement(TitleComponent, {
      label: label,
      key: key,
      columnKey: key,
      order: order,
      canSort: 'prevent' !== sort,
      index: index,
      moveColumn: moveColumn,
      updateOrder: updateOrder,
      styles: styles,
      width: width,
      htmlTable: htmlTable,
      headerStyle: headerStyle
    });
  });
  if (htmlTable) {
    return /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", {
      style: style
    }, children));
  } else {
    return /*#__PURE__*/React.createElement(View, {
      style: style
    }, children);
  }
};
export default Header;